import { InputRule } from '@tiptap/core'
import { Color } from '@tiptap/extension-color'
import Highlight from '@tiptap/extension-highlight'
import HorizontalRule from '@tiptap/extension-horizontal-rule'
import TiptapImage from '@tiptap/extension-image'
import TiptapLink from '@tiptap/extension-link'
import Placeholder from '@tiptap/extension-placeholder'
import { TableKit } from '@tiptap/extension-table'
import { TaskItem } from '@tiptap/extension-task-item'
import { TaskList } from '@tiptap/extension-task-list'
import { TextStyle } from '@tiptap/extension-text-style'
import TiptapUnderline from '@tiptap/extension-underline'
import StarterKit from '@tiptap/starter-kit'
import { Markdown } from 'tiptap-markdown'
import CustomKeymap from './custom-keymap'
import { GalleryExtension } from './gallery'
import { ImageExtension } from './image'
import { ImageModeToolbar } from './image-mode-toolbar'
import { LinkExtension } from './link'
import { LinkCardExtension } from './link-card'
import { Mathematics } from './mathematics'
import { Twitter } from './twitter'
import UpdatedImage from './updated-image'

import CharacterCount from '@tiptap/extension-character-count'
import CodeBlockLowlight from '@tiptap/extension-code-block-lowlight'
import Youtube from '@tiptap/extension-youtube'
import GlobalDragHandle from 'tiptap-extension-global-drag-handle'

const PlaceholderExtension = Placeholder.configure({
  placeholder: ({ node }) => {
    if (node.type.name === 'heading') {
      return `Heading ${node.attrs.level}`
    }
    return "Press '/' for commands"
  },
  includeChildren: false,
})

const HighlightExtension = Highlight.configure({
  multicolor: true,
})

const MarkdownExtension = Markdown.configure({
  html: false,
  transformCopiedText: true,
})

const Horizontal = HorizontalRule.extend({
  addInputRules() {
    return [
      new InputRule({
        find: /^(?:---|—-|___\s|\*\*\*\s)$/u,
        handler: ({ state, range }) => {
          const attributes = {}

          const { tr } = state
          const start = range.from
          const end = range.to

          tr.insert(start - 1, this.type.create(attributes)).delete(
            tr.mapping.map(start),
            tr.mapping.map(end),
          )
        },
      }),
    ]
  },
})

export * from './ai-highlight'
export * from './slash-command'
export {
  CharacterCount,
  CodeBlockLowlight,
  Color,
  CustomKeymap,
  GalleryExtension,
  GlobalDragHandle,
  HighlightExtension,
  Horizontal as HorizontalRule,
  ImageExtension,
  ImageModeToolbar,
  InputRule,
  LinkCardExtension,
  LinkExtension,
  MarkdownExtension,
  Mathematics,
  PlaceholderExtension as Placeholder,
  StarterKit,
  TableKit,
  TaskItem,
  TaskList,
  TextStyle,
  TiptapImage,
  TiptapLink,
  TiptapUnderline,
  Twitter,
  UpdatedImage,
  Youtube,
}
